import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from '~admin/client';
import { ClientProfileData } from '~admin/model/client-profile-data';
import { mapClientProfileData } from '~admin/model/client-profile-data.mapper';
import { ClientCreateRequest } from '~client/model/admin/client-create-request';
import { ClientProfileResponse } from '~client/model/client-profile-response';
import { OneArgTask, rxTask } from '~common/helper/mobx-tasks';

export type CreateClientTask = OneArgTask<ClientCreateRequest, ClientProfileData>;

/* Creates a new Client */
export const performCreateClient = (
  request: ClientCreateRequest,
): Observable<ClientProfileResponse> => apiClient.adminClientController.createClient$(request);

export const createClientTaskFactory = (): CreateClientTask =>
  rxTask<ClientCreateRequest, ClientProfileData>((request: ClientCreateRequest) =>
    performCreateClient(request).pipe(map(mapClientProfileData)),
  );



// WEBPACK FOOTER //
// ./interactor/client/perform-create-client.ts